import React from "react";
import { useHeaderProps } from "../../../components/Layouts/SubLayout/useHeaderProps";
import Form, { useForm } from "rc-field-form";
import { PushField } from "./Components/PushField";
import styles from "./index.module.scss";
import { SubField } from "./Components/SubField";
import useRequest, { errorMessage } from "../../../Utils/useRequest";
import {
    getNoticeSet,
    saveNoticeSet,
    SettingsData
} from "../../../API/settings";
import { message, Spin } from "antd";

export function SettingPush() {
    const [form] = useForm<SettingsData>();
    useHeaderProps({ title: "消息提醒设置" });

    const [data, { loading }] = useRequest(async () => {
        try {
            const data = await getNoticeSet();
            form.setFieldsValue(data);
            return data;
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    function onSave() {
        setTimeout(async () => {
            try {
                const newData = form.getFieldsValue();
                await saveNoticeSet(newData);
            } catch (e) {
                message.error(errorMessage(e));
            }
        });
    }

    return (
        <div className={styles.root}>
            <div className={styles.tip}>
                说明：开关打开，将接受到消息提醒。关闭开关，即不做实时提醒，但仍可在消息中心-互动消息中查看新消息
            </div>

            <Spin spinning={loading}>
                <Form form={form} onValuesChange={onSave} preserve={false}>
                    <PushField label="签到" name="sign" />
                    <PushField label="投票" name="vote" />
                    <PushField label="练习" name="exercise" />
                    <PushField label="作业" name="homework" />
                    <PushField label="考试" name="exam" />
                    <PushField label="私信" name="chat" />
                    <PushField label="问卷" name="evaluation" />
                    <PushField label="小组活动" name="groupActivity" />

                    <PushField label="答疑" name="answeringGroup">
                        <SubField
                            label="接收新评论的提醒"
                            name={["answering", "newFloor"]}
                        />
                        <SubField
                            label="接收我评论的提问有更新提醒"
                            name={["answering", "floorNewUpdate"]}
                        />
                        <SubField
                            label="接收评论有新回复的提醒"
                            name={["answering", "floorNewReply"]}
                        />
                        <SubField
                            label="接收我回复的评论有更新提醒"
                            name={["answering", "replyNewUpdate"]}
                        />
                    </PushField>

                    <PushField label="主题讨论" name="discussGroup">
                        <SubField
                            label="有新主题讨论提醒"
                            name={["discuss", "newDiscuss"]}
                        />
                        <SubField
                            label="我发言的讨论有更新提醒"
                            name={["discuss", "floorNewUpdate"]}
                        />
                        <SubField
                            label="我回复的发言有更新提醒"
                            name={["discuss", "replyNewUpdate"]}
                        />
                    </PushField>
                </Form>
            </Spin>
        </div>
    );
}
